<template>
    <v-app>
        <v-app-bar
     color="#fafafa"
     scroll-threshold="20"
      app
      elevate-on-scroll
      dense
    >

     <v-app-bar-nav-icon v-if="!drawer" @click="drawer = !drawer"></v-app-bar-nav-icon>
     <v-expand-x-transition>
     <v-toolbar-title style="width:99%" v-if="search">
       
 <v-text-field
            solo
            flat
            placeholder="Zoeken..."
            background-color="transparent"
            hide-details
            autofocus
            @blur="search=false",
            v-model="search"
          ></v-text-field>
          <v-divider v-show="search"></v-divider>

          </v-toolbar-title>
          </v-expand-x-transition>
        <v-spacer></v-spacer>

      <v-btn icon @click="search = !search" v-shortkey="['ctrl', 'f']" @shortkey="search = !search">
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn icon  v-if="!infobar" @click="infobar = !infobar">
        <v-avatar size="36">
            <img src="https://randomuser.me/api/portraits/women/81.jpg">
          </v-avatar>
        
      </v-btn>
    </v-app-bar>
    
     <v-navigation-drawer 
      v-model="drawer"
      :permanent="$vuetify.breakpoint.mdAndUp"
      app
      width="300">
       <template v-slot:prepend>
       <center class="pt-3">
         <img src="https://res.cloudinary.com/softwarenavigator/image/upload/v1566464048/nl/54f727fe782c29a00ee40807/logo_original.png" height="40">
       </center>
      <v-list-item class="mb-2">
        <v-list-item-content>
          <v-list-item-title class="text-center">
            Nederlands Kennis Centrum
          </v-list-item-title>
          <v-list-item-subtitle class="text-center">
            Vragenlijsttool voor aanvragers
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
</template>
      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in menu"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-navigation-drawer
      v-model="infobar"
      app
      right
      class=""
      floating
      color="#fafafa"
    >
      
        <v-list-item two-line>
          <v-list-item-avatar @click="infobar = !infobar">
            <img src="https://randomuser.me/api/portraits/women/81.jpg">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Jane Smith</v-list-item-title>
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      

      

      <v-list dense>
        <v-list-item
          v-for="item in menu"
          :key="item.title"
          @click=""
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-content id="scrolling" :class="{'my-50': $vuetify.breakpoint.lgAndUp}">
      <v-card
    flat
    class="transparent"
    max-width="1280"
  >
    <v-card-title class="display-1 pb-0 pt-0">Projectspace</v-card-title>
    
    <v-card-title class="subtitle-1 pt-0">De plek voor al uw projecten</v-card-title>
    <v-card-text class="pt-5 fill-height grid-list">
      <p>Welkom hieronder kunt u alle gegevens vinden mbt uw project en de onderligegnde gegevens</p>
      <v-container class="pa-0">
      <v-row>
        <v-col
          v-for="(item, i) in cards"
          :key="i"
          :class="{'block': item.selected}"
        >
          <v-expand-transition>
          <v-card
            :color="!item.selected ? item.color : ''"
            :dark="!item.selected"
            class="featured-card"
            outlined
            :hover="!item.selected"
            :ripple="!item.selected"
            @click="item.selected = !item.selected"
          >
            <v-list dark :color="item.color" class="pa-3 my-auto">
            <v-list-item three-line>
              <v-list-item-content class="align-self-start mt-3">
                <v-list-item-title
                  class="display-1"
                  v-text="item.title"
                ></v-list-item-title>

                <v-list-item-subtitle v-text="item.artist"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                size="80"
                class="ml-5"
                tile
              >
                <!--v-img :src="item.src"></v-img-->
                 <v-icon color="rgb(255, 255, 255, 0.5)" size="80">{{ item.icon }}</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            </v-list>
          <transition name="slide-fade">
            <v-card-text v-show="item.selected">
            <span>Number 10</span><br>
            <span class="text--primary">
              <span>Whitehaven Beach</span><br>
              <span>Whitsunday Island, Whitsunday Islands</span>
            </span>
          </v-card-text>
           </transition>
          </v-card>
          </v-expand-transition>
        </v-col>
      </v-row>
      </v-container>
       <v-toolbar flat color="transparent">
                  <v-toolbar-title>Expandable Table</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                  <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                </v-toolbar>
      
           <v-data-table
              :headers="headers"
              :items="list"
              flat
              dense
              :single-expand="singleExpand"
              :hide-default-header="singleExpand"
              :expanded.sync="expanded"
              item-key="name"
              show-expand
              class="elevation-1"
                   >
               
              <template v-slot:expanded-item="{ headers, item }">
                  
                <td class="text-left"></td><td :colspan="headers.length-1" class="text-left">
                   
                    <v-card
          class="mx-auto"
          max-width="400"
          flat
        >
          <v-img
            class="white--text"
            height="200px"
            src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
          >
            <v-card-title class="align-end fill-height">Top 10 Australian beaches</v-card-title>
          </v-img>
      
          <v-card-text>
            <span>Number 10</span><br>
            <span class="text--primary">
              <span>Whitehaven Beach</span><br>
              <span>Whitsunday Island, Whitsunday Islands</span>
            </span>
          </v-card-text>
      
          <v-card-actions>
            <v-btn
              text
              color="orange"
            >
              Share
            </v-btn>
            <v-btn
              text
              color="orange"
            >
              Explore
            </v-btn>
          </v-card-actions>
        </v-card>
        </td>
                
              </template>
              <template v-slot:item.name="{ item }">
                 <v-list color="transparent">
                      <v-list-item class="pl-0" >
                  <v-list-item-avatar color="blue">
                    <v-icon dark>account_box</v-icon>
                  </v-list-item-avatar>
          
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle>{{item.description | subStr}}<br></v-list-item-subtitle>
                  </v-list-item-content>
          
                  <v-list-item-action v-if="false">
                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-information</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
                <!--v-chip :color="getColor(item.calories)" dark>{{ item.calories }}</v-chip-->
              </template>
              <template v-slot:item.date="{ item }">
                {{item.date | moment("dddd DD MMMM YYYY")}}
              </template>
        </v-data-table>
        
            <v-card
                :class="{'mx-auto' : true, open : open}"
                max-width="400"
                raised
                
              >

                <v-img
                transition="scroll-y-transition"
                  :class="{'white--text animate-image': true, open:open}"
                  gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,.3)"
                  src="https://man-man.nl/app/uploads/2017/08/undercut-vuot-phong-01.jpg"
                >
                  <v-card-title class="align-end fill-height pb-5" style="justify-content: center;">
                      <div>Martin Brongers</div>
                     <div class="grey--text subtitle-1">Top webdesigner</div> 
                  </v-card-title>
                 
                </v-img>
                 <v-card-text class="card-contents pa-0">
                    <v-list three-line>
                      <template v-for="(item, index) in items">
                        <v-subheader
                          v-if="item.header"
                          :key="item.header"
                          v-text="item.header"
                        ></v-subheader>
                
                        <v-divider
                          v-else-if="item.divider"
                          :key="index"
                          :inset="item.inset"
                        ></v-divider>
                
                        <v-list-item
                          v-else
                          :key="item.title"
                          @click=""
                        >
                          <v-list-item-avatar>
                            <v-img :src="item.avatar"></v-img>
                          </v-list-item-avatar>
                
                          <v-list-item-content>
                            <v-list-item-title v-html="item.title"></v-list-item-title>
                            <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
 
            </v-card-text>
             <v-btn class="mx-2 card-fab" :large="!open" :small="open" fab dark color="pink" @click="open=!open">
                  <v-icon dark>add</v-icon>
                </v-btn>
                
                <v-card-text v-if="false">
                  <span>Number 10</span><br>
                  <span class="text--primary">
                    <span>Whitehaven Beach</span><br>
                    <span>Whitsunday Island, Whitsunday Islands</span>
                  </span>
                </v-card-text>
            <v-divider v-show="open"></v-divider>
                <v-card-actions>
                  <v-btn
                    text
                    color="orange"
                    to="project/6930726"
                  >
                    Open
                  </v-btn>
                  <v-btn
                    text
                    color="orange"
                  >
                    Explore
                  </v-btn>
                  <v-spacer></v-spacer>
                  
                            <v-btn text>
          <v-icon class="mr-1">mdi-heart</v-icon>
          <span class="subheading mr-2">256</span>
          <span class="mr-1">·</span></v-btn>
          <v-btn text>
          <v-icon class="mr-1">mdi-share-variant</v-icon>
          <span class="subheading">45</span></v-btn>
        
                </v-card-actions>
              </v-card>

    </v-card-text>
    <v-card-actions>
      <v-btn text>Click</v-btn>
    </v-card-actions>
  </v-card>
          
      </v-content>
      
  </v-app>
</template>
<script>
import {
  mapActions
} from 'vuex'
import { VueTyper } from 'vue-typer'
 export default {
     components: {
    // ES6; property shorthand + Vue should automatically dasherize the key for us
    VueTyper
   
  },
    props: [],
    data () {
      return {
        search: 'valew',
        drawer: true,
        infobar: false,
        search: false,
        dialog: false,
          expanded: [],
        singleExpand: false,
         headeritemlist: [{
            text: 'Dessert (100g serving)',
            align: 'left',
            sortable: false,
            value: 'name',
          }],
          headerlist: [
          {
            
            align: 'left',
            sortable: false,
            value: 'name',
          },
          { text: 'Status', value: 'status' },
          { text: 'Track', value: 'track' },
          { text: 'Datum', value: 'date' }
        ],
        list: [ ],
          open:false,
       step: 0,
       loading: false,
       message: ["Welkom!", "Laten we beginnen met het maken van een project", "Geef de naam van uw project op"],
       //message: "welkom",
       project: {},
       menu: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard' },
          { title: 'Photos', icon: 'mdi-image' },
          { title: 'About', icon: 'mdi-help-box' },
        ],
       items: [
        { header: 'Today' },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          title: 'Brunch this weekend?',
          subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          title: 'Oui oui',
          subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
          title: 'Birthday gift',
          subtitle: "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?",
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
          title: 'Recipe to try',
          subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
        },
      ],
      cardlist: [
        {
          color: 'green',
          src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
          icon: 'all_inclusive',
          title: '€ 3965,91',
          artist: 'Winst Q1 2019',
          selected: false
        },
        {
          color: 'red',
          src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
          icon: 'location_city',
          title: '41',
          artist: 'Leden',
          selected: false
        },
        {
          color: 'blue',
          src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
          icon: 'share',
          title: '553426',
          artist: 'Volgers',
          selected: false
        },
        {
          color: 'yellow',
          src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
          icon: 'share',
          title: '3',
          artist: 'Taken',
          selected: false
        },
      ]
      }
    },
    computed: {
        headers () {
            if (this.singleExpand) return this.headeritemlist
            return this.headerlist
        },
        index () {
            return this.$router.currentRoute.params.index
        },
        selected (){
          return this.cardlist.filter(q => q.selected).length > 0
        },
        cards () {
          return this.cardlist.sort(function(x, y) {
              // true values first
              return (x.selected === y.selected)? 0 : x.selected? -1 : 1;
              // false values first
              // return (x === y)? 0 : x? 1 : -1;
          })
        }
    },
     watch: {
         index (value) {
             this.init()
         }
    },
    $bus : {
      store_connected: function () {
        console.log('ready')
        this.init()
      }
    },
    $data: {
      list : {
        callback: "match.list",
        item: {},
        page_size: 100,
        q: "valew",
        source: "track"
      }
    },
     methods : {
         ...mapActions('project', ['getItem', 'saveItem', 'load']),
         init () {
           console.log('project init')
            if (!this.index) {
                this.load({next: function(list){
                    console.log(list)
                }})
            } else {
                var self = this
                this.getItem({item: {_id: 'project/' + this.index}, source: 'project', next: function (item){
                    console.log(item)
                    self.project = item     
                    self.step=2
                }})
            }
         },
         onComplete () {
            var self = this
           this.step++
           this.$nextTick(() => {
                setTimeout(() => {
                    if (self.$refs['input_step' + self.step]) self.$refs['input_step' + self.step].$el.querySelector("input").focus()
                },50)
            })
         },
         setName() {
           this.step = 2
           this.message = ["Bedankt!","Kunt u vertellen waar " + this.project.name + " om draait?"]
         },
         saveProject(){
             if (this.loading) return false
             var self = this
             this.loading=true
             const options = {
                    source: 'project', 
                    item: this.project,
                 next: function(response){
                     self.project = response
                     self.$router.push(response._id)
                     self.loading = false
                 }
             }
             this.saveItem(options)
         },
          getColor (calories) {
            if (calories > 400) return 'red'
            else if (calories > 200) return 'orange'
            else return 'green'
          }
     }
     
       
  }
</script>
<style>
.v-app-bar--is-scrolled {
  background-color:#ffffff!important;
  border-color:#ffffff!important;
}
 .v-card__title.subtitle-1 {
    color: rgba(0, 0, 0, 0.54);
  
}
.col,
.featured-card,
.featured-card .v-card__text{
  transition: all 500ms ease-in-out;
  transition-delay: 200ms;
}
.col.block {
  flex-basis: 100%;
  width:100%;
}
.featured-card{ 
  height:140px;
}
.col.block .featured-card{
  height: 500px;
}
.my-50{
  margin-left:50px;
  margin-right:50px;
}
.text-inset {
  background-color: #565656;
  color: transparent;
  text-shadow: 0px 4px 6px rgba(255,255,255,0.5);
  -webkit-background-clip: text;
     -moz-background-clip: text;
          background-clip: text;
}

    .vue-typer .char {
      font-family: Verdana!important;
      font-size: 3em!important;
    }
    .card-fab {
        position: absolute!important;
                transition: all 0.5s ease-in-out;
        margin-top: -64px;
        left: calc(50% - 32px)!important;
    }
     .v-card.open .card-fab.v-size--small {
        margin-top: -20px;
        left: calc(50% - 20px)!important;
        transform: rotate(315deg);
    }
    .card-contents {
     background: #F6FCFE;
     overflow:hidden;
     transition: all 0.5s ease-in-out;
     height:0;
     opacity:0;
    }
    .v-card.open .card-contents {
        height:calc(40vh - 80px);
     opacity:100;
     overflow:auto;
    }
    .animate-image{
        transition: all 0.5s ease-in-out;
        height:40vh;
    }
    .animate-image .v-image__image {
        transition: all 0.5s ease-in-out;
        background-size: 120%!important;
    }
     .v-card.open .animate-image{
        height: 80px;
        background-size: 100% 100%;
    }
      .v-card.open .animate-image .v-image__image{
         background-size: 100%!important;
     }
     .v-card__actions{
         transition: all 0.5s ease-in-out;
         margin-tops:50px;
         margin-bottoms:50px;
     }
      .v-card.open .v-card__actions {
          margin:0px;
      }
      td.text-left {
          padding-left:0px;
      }
      .v-data-table tbody tr.expanded.expanded__content {
            -webkit-box-shadow: none;
            box-shadow: none;
            transition: all 0.5s ease;
        }
        .v-data-table {
          width:100%;
        }
        
        .v-data-table__mobile-row:nth-child(2) .v-data-table__mobile-row__header {
          display:none
        }
        .v-data-table__mobile-row:nth-child(2) {
          height: auto;
        }
        .v-data-table__mobile-row:nth-child(2) .v-data-table__mobile-row__cell {
          text-align: left;
        }
        .slide-fade-enter-active {
          transition: all 0.5s ease;
        }
        .slide-fade-leave-active {
          transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
          transform: translateY(10px);
          opacity: 0;
        }
</style>